import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { TransportService } from 'src/app/services/Transport/transport.service';

@Component({
  selector: 'app-student-vehicle-wise',
  templateUrl: './student-vehicle-wise.component.html',
  styleUrls: ['./student-vehicle-wise.component.css']
})
export class StudentVehicleWiseComponent implements OnInit {

  constructor(private transportService:TransportService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }

  SearchFilter = {
    VehicleID:0,
}
VehicleList:any;
GetAllVehicle  () {
    this.lookupService.GetLookupsList('Vehicle', '').subscribe( (data)=> {
        this.VehicleList = data.LookupItems;
    });
};
Submitted = false;
Clear  () {
    this.SearchFilter.VehicleID = 0;
    this.Submitted = false;
}

 Validation() {
    return this.SearchFilter.VehicleID == 0;
}
loading = false;
VehicleDetailsList:any;
VehicleStudentList:any;
GetAllVehicleDetailsByStudent  () {
  this.VehicleStudentList=[];
    this.Submitted = true;
    this.spinnerService.show();     
        this.loading = true;
        this.Submitted = false;
       this.transportService.GetAllVehicleDetailsByStudent(JSON.stringify(this.SearchFilter)).subscribe( (response)=> {
            this.VehicleDetailsList = response.VehicleDetailsList;
            if (this.VehicleDetailsList != null) {
                this.VehicleStudentList = [];
                for (var i = 0; i < this.VehicleDetailsList.length; i++) {
                    if (this.VehicleDetailsList[i].StudentRouteList!=null) {
                    }
                    for ( var j = 0; j < this.VehicleDetailsList[i].StudentRouteList.length; j++) {
                        this.VehicleStudentList.push(this.VehicleDetailsList[i].StudentRouteList[j]);
                    }
                }
            }
         
            this.spinnerService.hide();
            this.globalHelper. CheckActionStatus(response);
        });
    
}
Print  () {
    var url = "printstudentvehiclewise?VehicleID=" + this.SearchFilter.VehicleID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
}


// Download

VehicleListDownload  () {
    this.JSONToCsvConverterVehicleList(this.VehicleStudentList, 'Vehicle_List', true);
};

 JSONToCsvConverterVehicleList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
        var row = "";
        row += 'Sr. No.' + ',';
        row += 'Student Name' + ',';
        row += 'Father Name' + ',';
        row += 'Mobile' + ',';
        row += 'Class' + ',';
        row += 'Section' + ',';
        row += 'Vehicle No.' + ',';
        row += 'Route' + ',';
        row += 'Location' + ',';
        row += 'Distance' + ',';
        row = row.slice(0, -1);
        CSV += row + '\r\n';
    }
    for (var i = 0; i < arrayData.length; i++) {
        var sno = i + 1;
        var row = "";
        row += '"' + sno + '",';
        row += '"' + arrayData[i].Name + '",';
        row += '"' + arrayData[i].FatherName + '",';
        row += '"' + arrayData[i].Mobile + '",';
        row += '"' + arrayData[i].ClassName + '",';
        row += '"' + arrayData[i].SectionName + '",';
        row += '"' + arrayData[i].VehicleNumber + '",';
        row += '"' + arrayData[i].RouteName + '",';
        row += '"' + arrayData[i].LocationName + '",';
        row += '"' + arrayData[i].Distance + '",';
        row.slice(0, row.length - 1);
        CSV += row + '\r\n';
    }
    if (CSV == '') {
        alert('Invalid Data');
        return;
    }
    var FileName = ReportTitle + '_' + moment(new Date()).format("DD-MMM-YYYY");

    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
}
  ngOnInit() {
    this.GetAllVehicle();
    this.GetAllVehicleDetailsByStudent();
  }

}
